import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
const INITIAL_STATE = {
  'url': '',
  'loading': false,
};
export const dowloadAccountReportWait = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.DOWNLOADING_ACCOUNT_REPORT]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DOWNLOADED_ACCOUNT_REPORT]: (state, action) => ({
      ...state,
      'loading': false,
      'url': action.response.excel,
    }),
    [ActionTypes.DOWNLOADED_ACCOUNT_REPORT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
    [ActionTypes.CLEAR_DOWNLOADED_ACCOUNT_REPORT]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
  })(state, action);
};
